import css from './modal.module.scss';

interface QuizButtonProps {
  applyMsg: string;
  cancelMsg: string;
  onApply: () => void;
  onCancel: () => void;
  applyBtnClass: string;
}

export default function QuizButtons({
  applyMsg,
  cancelMsg,
  onApply,
  onCancel,
  applyBtnClass
}: Readonly<QuizButtonProps>) {
  return (
    <div className={css.buttons}>
      <button className={css.cancel} onClick={onCancel}>
        {cancelMsg}
      </button>
      <button className={applyBtnClass} onClick={onApply}>
        {applyMsg}
      </button>
    </div>
  );
}
